import { downloadServerFile, polling } from '@/utils';
import bilingualAlignmentAjax from '@/services/bilingualAlignment';

const store = {
  namespaced: true, //命名空间
  state: {
    // 下载项配置
    downloadOptions: [
      { label: '原文', type: 1 },
      { label: '译文', type: 2 },
      { label: '原译对照', type: 3 },
      { label: 'TMX', type: 4 },
    ],
    // 下载loading状态
    downloadLoading: false,
  },
  getters: {
    downloadOptions: (state) => state.downloadOptions,
    downloadLoading: (state) => state.downloadLoading,
  },
  mutations: {
    // 设置下载loading值
    SET_DOWNLOAD_LOADING(state, payload) {
      state.downloadLoading = payload
    },
  },
  actions: {
    /**
     * @desc 更新loading值
     * @param {Boolean} payload 
     */
    updateDownloadLoading({ commit }, payload) {
      commit('SET_DOWNLOAD_LOADING', payload)
    },

    /**
    * @desc 下载原文1 译文2 原译对照3 TMX4
    * @param {Object} type 1 2 3 4 | fileId
    */
    async downloadFile({ dispatch }, params) {
      const { success, result } = await bilingualAlignmentAjax.exportAlignFile(params)
      if (success && result.taskKey) {
        const asyncResultparams = {
          taskKey: result.taskKey
        }
        // 打开下载loading
        dispatch('updateDownloadLoading', true)
        // 轮询获取文件地址和文件名称        
        const { downloadUrl, fileName, percent } = await polling(bilingualAlignmentAjax.getDownloadAsyncResultV2, asyncResultparams)
        if (percent !== 100) return
        // a链接下载
        downloadServerFile(fileName, downloadUrl)
        // 关闭下载loading
        dispatch('updateDownloadLoading', false)
      }
    }
  }
}





export default store